export const CLOSE_PIN_MODAL = "CLOSE_PIN_MODAL"
export const OPEN_PIN_MODAL = "OPEN_PIN_MODAL"